export enum UserRoles {
  CUSTOMER = "customer",
  LANDOWNER = "landowner",
  BUILDER = "builder",
  SUPER_ADMIN = "super-admin",
  LAWYER = "lawyer",
  SALES_PERSON = "sales-person",
}
